import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomTable } from '../../shared/uiComponents';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import MobileView from './mobileView';
import { Headers, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getInsurancesForAdmin } from '../../redux/State/clientSlice/insuranceSlice';
import './index.scss';
import { PageHeader } from '../../components/PageHeader';
import { Certificate } from '../../shared/Assets/menuIcons';

const Insurances = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const [params] = useSearchParams();
	const searchString = params.get('search') || '';

	const insurances = useSelector((state) => state.insurance.insurancesAdmin);
	const loading = useSelector((state) => state.insurance.loadingAdmin);

	useEffect(() => {
		dispatch(
			getInsurancesForAdmin({
				searchString,
			}),
		);
	}, [dispatch, searchString]);

	return (
		<Container>
			<Header>
				<PageHeader
					icon={<Certificate />}
					title="Insurances"
					isInContainer
					headerContent={<SearchBar style={{ marginTop: 0 }} />}
				/>
			</Header>
			<CustomTable
				headers={Headers}
				data={{ query: insurances }}
				TableBody={TableBody}
				loading={loading}
				hasPagination={false}
			/>
			<MobileView insurances={insurances} />
		</Container>
	);
};

export default Insurances;
